module.exports = "./img/e0c20e368579f67ecc0c801c8b06213a.png";